module.exports = __webpack_public_path__ + "static/media/TheVerge.7f7975c9.png";